import React from 'react';
import PropTypes from 'prop-types';

import { withPolaris } from 'Components/protons/Polaris';

import { Icon } from 'Components/atoms/Icon';

import './_style.scss';

const AnimatedChevrons = ({
  context: {
    cssPrefix,
  },
}) => (
  <div className={`${cssPrefix}__animated-chevrons`}>
    <Icon icon={`${cssPrefix}__ico-caret_down`} />
    <Icon icon={`${cssPrefix}__ico-caret_down`} />
    <Icon icon={`${cssPrefix}__ico-caret_down`} />
  </div>
);

AnimatedChevrons.defaultProps = {
  context: {},
};

AnimatedChevrons.propTypes = {
  context: PropTypes.shape({
    cssPrefix: PropTypes.string,
  }),
};

export default withPolaris(AnimatedChevrons);
